import React, { useState } from 'react';
import { FlagButton } from './PartDisplay';

const MatchingQuestion = ({
  questions,
  options,
  savedAnswers,
  onAnswerChange,
  title,
  flaggedQuestions,
  toggleFlagQuestion,
  exampleAnswers = [],
    showFullTextInButtons = false ,
  allowMultipleMatches = false // <-- NEW: Add prop with default
}) => {
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  const specialOptionId = options[options.length - 1].id;

  const handleQuestionSelect = (questionId) => {
    setSelectedQuestionId(prevId => (prevId === questionId ? null : questionId));
  };

  const handleOptionSelect = (optionId) => {
    if (!selectedQuestionId) return;

    const newAnswers = { ...savedAnswers };

    // --- MODIFIED: Only enforce 1-to-1 mapping if prop is false ---
    if (!allowMultipleMatches && optionId !== specialOptionId) {
      const otherQuestionId = Object.keys(newAnswers).find(
        (qid) => qid !== selectedQuestionId && newAnswers[qid] === optionId
      );
      if (otherQuestionId) {
        newAnswers[otherQuestionId] = null;
      }
    }
    // --- END MODIFICATION ---

    if (newAnswers[selectedQuestionId] === optionId) {
      newAnswers[selectedQuestionId] = null;
    } else {
      newAnswers[selectedQuestionId] = optionId;
    }

    onAnswerChange(newAnswers);
    setSelectedQuestionId(null);
  };

  return (
    <div className="space-y-3">
      {/* ... (Header is unchanged) ... */}
      {/*<div className="mb-2 p-3 bg-gray-100 rounded-none border border-gray-900">*/}
      {/*  <p className="text-sm text-gray-900 font-bold uppercase tracking-wide">*/}
      {/*    Situationen*/}
      {/*  </p>*/}
      {/*  <p className="text-xs text-gray-600 mt-1">*/}
      {/*    Klicken Sie auf eine Situation, um eine Anzeige zuzuordnen.*/}
      {/*  </p>*/}
      {/*</div>*/}

      {questions.map((q) => {
        // ... (This section's logic is unchanged) ...
        const selectedOptionId = savedAnswers[q.questionId];
        const selectedOption = options.find(o => o.id === selectedOptionId);
        const isSelected = selectedQuestionId === q.questionId;

        return (
          <div
            key={q.questionId}
            className={`
              bg-white rounded-none border-2 transition-all duration-200
              ${isSelected
                ? 'border-gray-900 shadow-lg'
                : selectedOption
                  ? 'border-gray-900 bg-gray-50'
                  : 'border-gray-400 hover:border-gray-900'
              }
            `}
          >
            {/* ... (Situation Info Bar is unchanged) ... */}
            <div
              onClick={() => handleQuestionSelect(q.questionId)}
              className={`
                p-4 flex items-center justify-between min-h-[72px] cursor-pointer
                ${isSelected 
                  ? 'bg-gray-900 text-white' 
                  : selectedOption 
                    ? '' 
                    : 'hover:bg-gray-50'
                }
              `}
            >
              <div className="flex items-start flex-1">
                <FlagButton
                  questionId={q.questionId}
                  flaggedQuestions={flaggedQuestions}
                  toggleFlagQuestion={toggleFlagQuestion}
                  className={isSelected ? 'flag-light' : ''}
                />
                <p className={`font-semibold ml-2 ${isSelected ? 'text-white' : 'text-gray-900'}`}>
                  <span className={`font-bold mr-2 ${isSelected ? 'text-gray-300' : 'text-gray-500'}`}>
                    {q.number}.
                  </span>
                  {q.text}
                </p>
              </div>
              <div className="text-right ml-4">
                {selectedOption ? (
                  <span className="font-bold text-2xl text-blue-700">{selectedOption.id.toUpperCase()}</span>
                ) : isSelected ? (
                  <div className="w-10 h-10 bg-white rounded-md flex items-center justify-center">
                    <span className="text-gray-900 font-bold text-xl">?</span>
                  </div>
                ) : (
                  <div className="w-10 h-10 bg-gray-200 rounded-md"></div>
                )}
              </div>
            </div>

            {/* --- MODIFIED Options Grid --- */}
            {isSelected && (
              <div className="p-4 border-t-2 border-gray-900 bg-gray-50">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-700 mb-3">
                  {title || 'Anzeige wählen'}:
                </p>
                <div className="grid grid-cols-2 gap-3">
                  {options.map(option => {
                    // --- MODIFIED DISABLED/USED LOGIC ---

                    // Check if used by an *example*
                    const isUsedByExample = exampleAnswers.includes(option.id);

                    // This is the *only* thing that should disable a button
                    const isDisabled =
                      option.id !== specialOptionId && isUsedByExample;

                    // Check if used by another *real* question (for styling only)
                    const questionUsingThisOption = Object.keys(savedAnswers).find(
                      (qid) => savedAnswers[qid] === option.id
                    );
                    const isUsedByAnotherRealQuestion =
                      questionUsingThisOption &&
                      questionUsingThisOption !== selectedQuestionId;

                    // Show "used" style only if 1-to-1 and used by another question
                    const isUsed =
                      !allowMultipleMatches &&
                      option.id !== specialOptionId &&
                      isUsedByAnotherRealQuestion;

                    // --- END MODIFICATION ---

                    return (
                      <button
                        key={option.id}
                        onClick={() => handleOptionSelect(option.id)}
                        disabled={isDisabled} // FIX: Only disable for examples
                        className={`
                          p-4 h-16 flex items-center justify-center rounded-none border-2 font-bold text-xl transition-all
                          ${isDisabled
                            ? 'bg-gray-100 border-gray-300 text-gray-500 line-through cursor-not-allowed' // Style for disabled (example)
                            : isUsed // <--- FIX: Use the 'isUsed' variable
                              ? 'bg-gray-100 border-gray-400 text-gray-400 hover:border-gray-900 hover:bg-gray-900 hover:text-white' // NEW: Style for used (but clickable/swappable)
                              : 'bg-white border-gray-400 text-gray-900 hover:border-gray-900 hover:bg-gray-900 hover:text-white'
                          }
                        `}
                      >
                        {showFullTextInButtons ? option.text : option.id.toUpperCase()}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MatchingQuestion;